import { testimonials } from '@/mocks/homepage';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            用户好评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实用户的使用反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.name}
              className="p-6 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < item.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-100 text-accent-700 rounded-full text-sm font-semibold">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}